import { isoDay, toCsv } from "src/pages/cases/csv";

// Customers as a CSV file, one row per account, with what the list shows.
const COLUMNS = [
  { label: "Customer", value: (c) => c.id },
  { label: "First name", value: (c) => c.first_name || "" },
  { label: "Last name", value: (c) => c.last_name || "" },
  { label: "Email", value: (c) => c.email || "" },
  { label: "Applications", value: (c) => c.application_count ?? "" },
  { label: "Last application", value: (c) => isoDay(c.last_application_at) },
  { label: "Paid (USD)", value: (c) => (c.paid_total === undefined ? "" : Number(c.paid_total).toFixed(2)) },
  { label: "Owes (USD)", value: (c) => (c.owed_total === undefined ? "" : Number(c.owed_total).toFixed(2)) },
  { label: "Test account", value: (c) => (c.is_test === undefined ? "" : c.is_test ? "Yes" : "No") },
  { label: "Can sign in", value: (c) => (c.is_active == 1 || c.is_active === true ? "Yes" : "No") }, // eslint-disable-line eqeqeq
];

export const customersCsv = (rows) => toCsv(rows, COLUMNS);
